// 与后端 llmconfig.NormalizeExtraConfigJSON 同口径的前端预校验,
// 避免保存后才收 400。规则:空=合法;≤16KB;顶层 JSON 对象;json_extra_body 若存在必须是对象。
const MAX_EXTRA_CONFIG_BYTES = 16 * 1024;

export type LLMExtraConfigError = 'tooLarge' | 'invalidJson' | 'notObject' | 'jsonExtraBodyNotObject';

export function validateLLMExtraConfig(value: string): LLMExtraConfigError | null {
  const v = value.trim();
  if (!v) return null;
  if (new TextEncoder().encode(v).length > MAX_EXTRA_CONFIG_BYTES) return 'tooLarge';

  let parsed: unknown;
  try {
    parsed = JSON.parse(v);
  } catch {
    return 'invalidJson';
  }
  if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) return 'notObject';

  const jeb = (parsed as Record<string, unknown>)['json_extra_body'];
  if (jeb !== undefined && (typeof jeb !== 'object' || jeb === null || Array.isArray(jeb))) {
    return 'jsonExtraBodyNotObject';
  }
  return null;
}
